import React, { useMemo, useState, useEffect } from "react";
import * as Dialog from "@radix-ui/react-dialog";
// import { Cross2Icon } from "@radix-ui/react-icons";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Button } from "../../atoms/button/index.js";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

import { IoGiftOutline } from "react-icons/io5";

export default function ModalDialogInline({
  triggerText,
  sponsorSubscription,
  sponsoredSubsLeft,
  simpleText = false,
}) {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = React.useState(" ");
  const [open, setOpen] = useState(false);
  const [submitted, setSubmitted] = useState(true);
  const [inputIsDisabled, setInputIsDisabled] = useState(false);

  const member = useSelector((state) => {
    return get(state, ["member"], null);
  });
  useEffect(() => {
    setInputIsDisabled(false);

    return () => {};
  }, []);

  const disabled = useMemo(
    () => submitted || emailError !== "",
    [submitted, emailError]
  );

  const styles = {
    trigger: {
      //   background: "#2563eb",
      //   color: "#fff",
      fontWeight: "bold",
      padding: simpleText ? "0.25rem 1rem" : "0.5rem 1.25rem",
      borderRadius: "0.5rem",
      border: 0,
      cursor: "pointer",
      fontSize: "1.25rem",
    },
    triggerHover: { background: "#1e4fd1", color: "#fff" },

    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      animation: "fadeIn 200ms ease-out",
    },

    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      width: "90%",
      maxWidth: 640,
      backgroundColor: "var(--component-background-neutral-default)",
      transform: "translate(-50%, -50%)",
      // background: "#ffffff",
      borderRadius: "0.75rem",
      padding: "1.5rem 1.75rem 2rem",
      boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
      animation: "scaleIn 200ms ease-out",
      fontFamily:
        'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif',
    },

    close: {
      position: "absolute",
      top: "0.75rem",
      right: "0.75rem",
      background: "transparent",
      border: 0,
      cursor: "pointer",
      color: "#374151",
    },
    closeHover: { color: "#111827" },

    title: {
      margin: "0 0 1rem",
      fontSize: "1.5rem",
      fontWeight: 600,
      textAlign: "center",
      color: "var(--text-neutral-default)",
    },

    label: {
      display: "block",
      fontSize: "1.2rem",
      color: "var(--text-neutral-default)",
      marginBottom: "0.25rem",
      textAlign: "center",
    },

    input: {
      width: "100%",
      padding: "0.5rem 0.75rem",
      border: "1px solid #d1d5db",
      borderRadius: "0.5rem",
      fontSize: "0.975rem",
      marginBottom: "1.25rem",
      marginTop: "1rem",
    },
    inputFocus: {
      outline: "2px solid #3b82f6",
      borderColor: "transparent",
    },

    submit: {
      width: "100%",
      background: disabled
        ? "var(--accent-7)"
        : "var(--component-background-accent-solid-default)",
      color: "#fff",
      fontWeight: 600,
      padding: "0.6rem 1rem",
      borderRadius: "0.5rem",
      border: 0,
      cursor: "pointer",
    },
    submitHover: {
      background: "var(--component-background-accent-solid-hover)",
    },
  };

  const [hover, setHover] = React.useState({
    trigger: false,
    close: false,
    submit: false,
  });

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const val = e.target.value;
    setEmail(val);

    if (val === "") setEmailError("Email is a required field");
    else if (e.target.value === member?.email)
      setEmailError(
        "You can’t use the free subscription for yourself. Please enter your friend’s email"
      );
    else if (!validateEmail(val)) {
      setEmailError(
        "Incorrect email address format. Please add the correct email"
      );
    } else {
      setEmailError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setInputIsDisabled(true);
      setSubmitted(true);
      await sponsorSubscription(email);
      window.alert(
        "Success! The subscription is done. Your friend has received an email with the subscription details."
      );
    } catch (err) {
      console.error("Error:", err);
      setSubmitted(true);
      window.alert(
        "Oops! There seems to be a technical error. Please try again or email us at subscription@newslaundry.com"
      );
    } finally {
      setOpen(false);
      setInputIsDisabled(false);
    }
  };
  const handleOpenChange = (isOpen) => {
    setOpen(isOpen);
    if (isOpen) {
      setSubmitted(false);
      setEmail("");
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      {/* Trigger button */}
      <Dialog.Trigger asChild>
        {!simpleText ? (
          <Button
            style={{
              ...styles.trigger,
              ...(hover.trigger && styles.triggerHover),
            }}
            onMouseEnter={() => setHover((h) => ({ ...h, trigger: true }))}
            onMouseLeave={() => setHover((h) => ({ ...h, trigger: false }))}
          >
            {triggerText}
          </Button>
        ) : (
          <div
            style={{
              ...styles.trigger,
              ...(hover.trigger && styles.triggerHover),
            }}
            onMouseEnter={() => setHover((h) => ({ ...h, trigger: true }))}
            onMouseLeave={() => setHover((h) => ({ ...h, trigger: false }))}
          >
            {triggerText}
          </div>
        )}
      </Dialog.Trigger>

      {/* Portal keeps dialog outside normal DOM flow */}
      <Dialog.Portal>
        {/* Overlay */}
        <Dialog.Overlay style={styles.overlay} />

        {/* Modal content */}
        <Dialog.Content style={styles.content}>
          {/* Close (×) button */}
          <Dialog.Close
            asChild
            style={{
              ...styles.close,
              ...(hover.close && styles.closeHover),
            }}
            onMouseEnter={() => setHover((h) => ({ ...h, close: true }))}
            onMouseLeave={() => setHover((h) => ({ ...h, close: false }))}
          >
            <button aria-label="Close">
              {/* <Cross2Icon width={20} height={20} /> */}
            </button>
          </Dialog.Close>

          {/* Title */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <IoGiftOutline
              size={36}
              color="var(--component-background-accent-solid-default)"
            />
          </div>
          <div style={styles.title}>Gift a free 30-day subscription</div>

          {/* Input + Action */}
          <label htmlFor="email" style={styles.label}>
            As a Gamechanger annual subscriber, you can gift 4 x one-month of
            {"\n"}
            free subscriptions to your friend
          </label>
          <form onSubmit={handleSubmit}>
            {emailError && (
              <span
                style={{
                  color: "red",
                  fontSize: "0.875rem",
                  marginTop: "0.25rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {emailError}
              </span>
            )}
            <input
              id="email"
              type="email"
              placeholder="Who are you gifting the subscription to? Enter their email address"
              value={email}
              onChange={handleEmailChange}
              style={styles.input}
              onFocus={(e) => Object.assign(e.target.style, styles.inputFocus)}
              onBlur={(e) => Object.assign(e.target.style, styles.input)}
              required
              disabled={inputIsDisabled}
            />

            <button
              disabled={disabled}
              style={{
                ...styles.submit,
                ...(hover.submit && disabled && styles.submitHover),
              }}
              onMouseEnter={() => setHover((h) => ({ ...h, submit: true }))}
              onMouseLeave={() => setHover((h) => ({ ...h, submit: false }))}
            >
              {inputIsDisabled ? "Please wait..." : "Gift Free Subscription"}
            </button>
          </form>

          {/* <button
            style={{
              ...styles.submit,
              ...(hover.submit && styles.submitHover),
            }}
            onMouseEnter={() => setHover((h) => ({ ...h, submit: true }))}
            onMouseLeave={() => setHover((h) => ({ ...h, submit: false }))}
          >
            Sponsor Subscription
          </button> */}

          <div
            style={{
              textDecoration: "",
              textAlign: "center",
              marginTop: "0.8rem",
              fontSize: "1.2rem",
              color: "var(--text-accent-default)",
            }}
          >
            {" "}
            {sponsoredSubsLeft} of 4 free{" "}
            {`${sponsoredSubsLeft > 1 ? "subcriptions" : "subcription"}`}{" "}
            available
          </div>
          <div
            style={{
              textDecoration: "underline",
              textAlign: "center",
              marginTop: "0.8rem",
              fontSize: "0.95rem",
              color: "var(--text-accent-muted)",
            }}
            onClick={() => {
              setOpen(false);
            }}
          >
            {" "}
            I will do it later (you can gift free subscriptions from the my
            account page)
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
